import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useAuth } from "./AuthContext";
import { apiService } from "../services/api";

const ClubContext = createContext();

export const useClub = () => {
  const context = useContext(ClubContext);
  if (!context) {
    throw new Error("useClub must be used within a ClubProvider");
  }
  return context;
};

export const ClubProvider = ({ children }) => {
  const { user } = useAuth();
  const [clubs, setClubs] = useState([]);
  const [currentClub, setCurrentClub] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadClubs = useCallback(async () => {
    if (!user) return;

    setLoading(true);
    try {
      if (user.role === "super_admin") {
        const clubsData = await apiService.getAllClubs();
        setClubs(clubsData);
      } else if (user.club_id) {
        const clubData = await apiService.getClub(user.club_id);
        setClubs([clubData]);
        setCurrentClub(clubData);
      }
    } catch (error) {
      console.error("Error loading clubs:", error);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    if (user) {
      loadClubs();
    }
  }, [user, loadClubs]);

  const createClub = async (clubData) => {
    try {
      const newClub = await apiService.createClub(clubData);
      setClubs((prev) => [newClub, ...prev]);
      return newClub;
    } catch (error) {
      throw error;
    }
  };

  const value = {
    clubs,
    currentClub,
    loading,
    loadClubs,
    createClub,
    setCurrentClub,
  };

  return <ClubContext.Provider value={value}>{children}</ClubContext.Provider>;
};
